var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnisat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9003_20246",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 2,
    width: 17,
    height: 22
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6953 2.92163H5.63281V23.0785H21.6953V2.92163Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9003_20246)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.9631 4.73527L21.1684 8.83216C21.5264 9.18015 21.7026 9.53226 21.6971 9.88709C21.6915 10.2419 21.5375 10.5653 21.2364 10.8587C20.9215 11.1658 20.5816 11.3214 20.2181 11.3282C19.8545 11.3337 19.4938 11.1617 19.1358 10.8137L14.8348 6.62404C14.3464 6.14777 13.8746 5.81067 13.4209 5.61279C12.9672 5.4149 12.4899 5.38351 11.9905 5.51999C11.4896 5.65509 10.9527 6.0031 10.3769 6.56262C9.58326 7.33642 9.20447 8.06245 9.24334 8.74073C9.28217 9.41898 9.6762 10.1232 10.4241 10.8506L14.7598 15.0757C15.122 15.4278 15.2995 15.7799 15.294 16.1293C15.2884 16.48 15.133 16.8035 14.8264 17.1023C14.5212 17.3998 14.184 17.5554 13.8177 17.5677C13.4515 17.58 13.0866 17.4094 12.7258 17.0573L8.52046 12.9604C7.83645 12.2944 7.34251 11.6639 7.03867 11.0689C6.73481 10.4739 6.62104 9.80111 6.70013 9.05051C6.77089 8.40773 6.98039 7.78542 7.33003 7.18222C7.67828 6.579 8.17776 5.96215 8.82571 5.33029C9.59712 4.57833 10.3339 4.00242 11.0359 3.60119C11.7366 3.19997 12.415 2.97752 13.0699 2.93112C13.7262 2.88472 14.3727 3.013 15.0123 3.31597C15.652 3.61894 16.3013 4.09113 16.9617 4.73527H16.9631Z",
    fill: "url(#paint0_linear_9003_20246)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3655 21.2662L6.16156 17.1694C5.8036 16.82 5.62739 16.4693 5.63294 16.1144C5.63849 15.7596 5.7925 15.4362 6.09357 15.1427C6.40852 14.8357 6.74845 14.6801 7.11196 14.6733C7.47547 14.6678 7.83621 14.8384 8.19417 15.1878L12.4939 19.3775C12.9836 19.8537 13.454 20.1908 13.9077 20.3887C14.3614 20.5866 14.8387 20.6166 15.3395 20.4815C15.8404 20.3464 16.3773 19.9984 16.9531 19.4375C17.7468 18.6637 18.1255 17.9377 18.0867 17.2594C18.0478 16.5812 17.6538 15.877 16.906 15.1482L14.5959 12.9169C14.2337 12.5648 14.0561 12.2127 14.0617 11.8633C14.0672 11.5126 14.2226 11.1892 14.5293 10.8903C14.8345 10.5928 15.1717 10.4372 15.5379 10.4249C15.9042 10.4127 16.2691 10.5832 16.6299 10.9353L18.8082 13.0384C19.4922 13.7043 19.9861 14.3348 20.29 14.9299C20.5938 15.5249 20.7076 16.1977 20.6285 16.9483C20.5577 17.591 20.3482 18.2134 19.9986 18.8166C19.6503 19.4198 19.1509 20.0366 18.5029 20.6685C17.7315 21.4204 16.9948 21.9964 16.2927 22.3976C15.5906 22.7988 14.9122 23.0226 14.2559 23.069C13.5997 23.1154 12.9531 22.9871 12.3135 22.6842C11.6739 22.3812 11.0246 21.909 10.3641 21.2649L10.3655 21.2662Z",
    fill: "url(#paint1_linear_9003_20246)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9876 10.6951C13.8405 10.6951 14.5318 10.015 14.5318 9.17614C14.5318 8.33727 13.8405 7.65723 12.9876 7.65723C12.1347 7.65723 11.4434 8.33727 11.4434 9.17614C11.4434 10.015 12.1347 10.6951 12.9876 10.6951Z",
    fill: "url(#paint2_radial_9003_20246)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9003_20246",
    x1: 20.4768,
    y1: 7.12213,
    x2: 7.51602,
    y2: 12.9779,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#201C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#77390D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#EA8101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4B852"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9003_20246",
    x1: 7.21203,
    y1: 19.0482,
    x2: 22.2733,
    y2: 14.491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F1D1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#77390D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#EA8101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4FB52"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_9003_20246",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.9876 9.17753) scale(1.54423 1.51893)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4B852"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#EA8101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#77390D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#211C1D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnisat);
export default __webpack_public_path__ + "static/media/unisat.d9c67cce5ec813d322330a0bc1bcbd4d.svg";
export { ForwardRef as ReactComponent };